<template>
  <el-card>
    <template #header>
      <content-header/>
    </template>
    <el-row type="flex" justify="center">
      <lz-form
        ref="form"
        :get-data="getData"
        :submit="onSubmit"
        :errors.sync="errors"
        :form.sync="form"
        :edit-mode="editMode"
        :rules="rules"
      >
        <el-form-item label="押金卡名：" required prop="name">
          <el-input v-model="form.name"/>
        </el-form-item>
        <!-- <el-form-item label="有效天数：" required prop="effective_days">
          <el-select
            v-model="form.effective_days"
            placeholder="选择有效天数"
            clearable
          >
            <el-option
              v-for="i of effective_days"
              :key="i.value"
              :label="i.label"
              :value="i.value"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item label="有效天数：" required prop="effective_days">
          <el-input-number
            v-model="form.effective_days"
            :min="1"
            :max="365"
            :precision="0"
            :step="1"
            label="有效天数"
          />
        </el-form-item>
        <el-form-item label="价格：" required prop="price">
          <el-input-number
            v-model="form.price"
            :precision="2"
            :step="0.1"
            :max="1000"
          />
        </el-form-item>
        <el-form-item label="是否折扣：" required prop="is_discount">
          <el-radio v-model="form.is_discount" :label="is_discount0" border>无折扣</el-radio>
          <el-radio v-model="form.is_discount" :label="is_discount1" border>有折扣</el-radio>
        </el-form-item>

        <el-form-item
          v-show="form.is_discount == 1"
          label="折扣："
          required
          prop="discount"
        >
          <el-input-number
            v-model="form.discount"
            :precision="0"
            :step="1"
            :max="100"
            :min="10"
          />
        </el-form-item>
        <el-form-item label="区域" prop="area_id">
          <el-select
            filterable
            clearable
            v-model="form.area_id"
            placeholder="请选择"
          >
            <el-option
              v-for="item in areas"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="是否可赠送：" required prop="is_give">
          <el-radio v-model="form.is_give" :label="is_give0" border>不可赠送</el-radio>
          <el-radio v-model="form.is_give" :label="is_give1" border>可赠送</el-radio>
        </el-form-item>
        <el-form-item label="是否启用：" required prop="status">
          <el-radio v-model="form.status" :label="status1" border>启用</el-radio>
          <el-radio v-model="form.status" :label="status0" border>停用</el-radio>
        </el-form-item>
        <!-- <el-form-item label="权限" prop="permissions">
          <el-select
            v-model="form.permissions"
            multiple
            placeholder="选择权限"
            filterable
            clearable
          >
            <el-option
              v-for="i of permissions"
              :key="i.id"
              :label="i.name"
              :value="i.id"
            />
          </el-select>
        </el-form-item> -->
      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
import LzForm from '@c/LzForm'
import { storeDepositCard, editDepositCard, updateDepositCard } from '@/api/deposit-cards'
import { getAreas } from '@/api/area'
import FormHelper from '@c/LzForm/FormHelper'

export default {
  name: 'Form',
  components: {
    LzForm,
  },
  mixins: [
    FormHelper,
  ],
  data() {
    return {
      form: {
        name: '',
        effective_days: '',
        price: 0,
        discount: 1,
        is_discount: 0,
        status: 0,
        area_id: '',
        is_give: 0,

      },
      rules: {},
      errors: {},
      areas: [],
      status1: 1,
      status0: 0,
      is_give0: 0,
      is_give1: 1,
      is_discount0: 0,
      is_discount1: 1,
      effective_days: [
        {
          value: 1,
          label: '一天',
        },
        {
          value: 3,
          label: '三天',
        },
        {
          value: 7,
          label: '七天',
        },
        {
          value: 15,
          label: '十五天',
        },
        {
          value: 30,
          label: '三十天',
        },
        {
          value: 90,
          label: '九十天',
        },
        {
          value: 180,
          label: '一百八十天',
        },
      ],
      permissions: [],
    }
  },
  methods: {
    async onSubmit() {
      if (this.editMode) {
        await updateDepositCard(this.resourceId, this.form)
      } else {
        await storeDepositCard(this.form)
      }
    },
    async getData() {
      const [
        { data: areas },
      ] = await Promise.all([
        getAreas({ all: 1 }),
      ])

      this.areas = areas

      if (this.editMode) {
        const { data } = await editDepositCard(this.resourceId)
        // data.areas = data.areas.map(i => i.id)
        this.fillForm(data)
      }
    },
  },
}
</script>
